import { render, staticRenderFns } from "./HabitAlternateAction.vue?vue&type=template&id=34c38810&"
import script from "./HabitAlternateAction.vue?vue&type=script&lang=js&"
export * from "./HabitAlternateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports